import script from "./MentionsLegales.vue?vue&type=script&setup=true&lang=js"
export * from "./MentionsLegales.vue?vue&type=script&setup=true&lang=js"

import "./MentionsLegales.vue?vue&type=style&index=0&id=d3d4476e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3d4476e"]])

export default __exports__